<template>
  <div>
    <el-card>
      <el-row>
        <el-col>
          <el-date-picker
            v-model="indexInfo.date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            @change="GetHe_FoodEverydayDetailList"
          >
          </el-date-picker>
          <!-- <el-button type="goon" style="margin-left: 20px" @click="GetHe_FoodEverydayDetailList">查询</el-button> -->
        </el-col>
      </el-row>
    </el-card>
    <el-card style="margin-top: 20px">
      <el-button type="goon" @click="onClickAdd">新增食材</el-button>
      <el-button type="goon" @click="Export_GetHe_FoodEverydayDetailList"
        >进货单生成</el-button
      >
    </el-card>
    <el-card style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        :header-cell-style="{
          background: '#F2F5FF',
          color: '#333',
          'text-align': 'center',
        }"
        border
      >
        <el-table-column label="序号" width="60" align="center">
          <template slot-scope="scope">
            {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="He_FoodLibraryName" label="名称" align="center">
        </el-table-column>
        <el-table-column prop="AliasName" label="别名" align="center">
        </el-table-column>
        <el-table-column prop="TypeName" label="食材种类" align="center">
        </el-table-column>
        <el-table-column prop="Nutrient" label="营养元素" align="center">
        </el-table-column>
        <el-table-column prop="Weight" label="重量（500g）" align="center">
        </el-table-column>
        <el-table-column prop="EdiblePart" label="可食部（%）" align="center">
        </el-table-column>
        <el-table-column prop="WeightType" label="毛/净" align="center">
        </el-table-column>
        <el-table-column
          prop="EdiblePartWeight"
          label="可食部重量（500g）"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="color: #4083fe"
              @click="onEditRowData(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="text"
              @click="onClickDelete(scope.row)"
              style="color: #e14747"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="flex-between">
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="PageSize"
          :total="total"
          style="text-align: center;padding:20px; 0 0 0"
        >
        </el-pagination>
        <el-button @click="$router.go(-1)">返回</el-button>
      </div>
    </el-card>
    <!-- 新增 -->
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="50%">
      <div>
        <el-form
          :model="ruleForm"
          ref="ruleForm"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="食材名称">
            <el-autocomplete
              v-model="ruleForm.he_FoodLibraryName"
              :fetch-suggestions="querySearchAsync"
              :trigger-on-focus="false"
              placeholder="请输入食材关键字"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="食材重量">
            <el-input
              type="number"
              placeholder="请输入食材重量（斤）"
              v-model="ruleForm.weight"
            ></el-input>
          </el-form-item>
          <el-form-item label="净重毛重">
            <el-select placeholder="请选择" v-model="ruleForm.weightType">
              <el-option label="净重" value="净重"></el-option>
              <el-option label="毛重" value="毛重"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="营养成分">
            <el-input type="textarea" v-model="ruleForm.Nutrient"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="Title == '新增今日上报食材' ? addSubmit() : editSubmit()"
          >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetHe_FoodEverydayDetailList,
  AddHe_FoodEveryDayDetail,
  GetFoodLibrary,
  DelHe_FoodEveryDayDetail,
  UpdateHe_FoodEveryDayDetail,
  Export_GetHe_FoodEverydayDetailList,
} from "../../../api/api";

export default {
  data() {
    return {
      tableData: [],
      PageSize: 10,
      PageIndex: 1,
      total: 0,
      dialogVisible: false,
      Title: "",
      indexInfo: {
        date: "",
      },
      ruleForm: {
        he_FoodLibraryName: "",
        Nutrient: "",
        weightType: "",
        weight: "",
        he_FoodLibraryId: 0,
      },
      userInfo: {},
      ishave: false,
      foodList: [],
    };
  },
  async created() {
    this.userInfo = JSON.parse(window.localStorage.user);

    await this.getNowTime();
    await this.GetHe_FoodEverydayDetailList();
  },
  methods: {
    async Export_GetHe_FoodEverydayDetailList() {
      if (this.ishave == false) {
        this.$message({
          type: "error",
          message: "下载失败，今日食材暂未生成",
        });
        return;
      }
      const params = {
        Id: this.$route.query.Id,
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.indexInfo.date,
        EndDate: this.indexInfo.date,
        PageSize: this.PageSize,
        PageIndex: this.PageIndex,
      };
      window.open(
        "http://importv3.mushroomisland.cn/api/mgd/He_FoodEverydayControlle/Export_GetHe_FoodEverydayDetailList?SchoolId=" +
          this.userInfo.SchoolId +
          "&StartDate=" +
          this.indexInfo.date +
          "&EndDate=" +
          this.indexInfo.date +
          "&PageSize=" +
          this.PageSize +
          "&PageIndex=" +
          this.PageIndex +
          "",
        "_blank"
      );
    },
    async editSubmit() {
      const params = {
        Id: this.ruleForm.Id,
        SchoolId: this.userInfo.SchoolId,
        he_FoodLibraryId: this.ruleForm.he_FoodLibraryId,
        he_FoodLibraryName: this.ruleForm.he_FoodLibraryName,
        Nutrient: this.ruleForm.Nutrient,
        weight: this.ruleForm.weight,
        weightType: this.ruleForm.weightType,
        reporter: this.userInfo.uRealName,
        reportDateString: this.indexInfo.date,
      };
      let res = await UpdateHe_FoodEveryDayDetail(params);
      if (res.data.success) {
        this.$message({
          type: "success",
          message: res.data.msg,
        });
        this.resetData();
        this.dialogVisible = false;
        await this.GetHe_FoodEverydayDetailList();
      } else {
        this.$message({
          type: "error",
          message: res.data.msg,
        });
      }
    },
    // 编辑
    onEditRowData(row) {
      this.Title = "编辑今日上报食材";

      this.ruleForm = {
        he_FoodLibraryName: row.He_FoodLibraryName,
        Nutrient: row.Nutrient,
        weightType: row.WeightType,
        weight: row.Weight,
        he_FoodLibraryId: row.He_FoodLibraryId,
        He_FoodEveryDayId: row.He_FoodEveryDayId,
        Id: row.Id,
      };
      this.GetFoodLibrary();
      this.dialogVisible = true;
    },
    onClickDelete(row) {
      this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = await DelHe_FoodEveryDayDetail({ ids: [row.Id] });
        if (res.data.success) {
          this.$message({
            type: "success",
            message: "删除成功!",
          });
          this.GetHe_FoodEverydayDetailList();
        } else {
          this.$message({
            type: "error",
            message: "删除失败!",
          });
        }
      });
    },
    async addSubmit() {
      if (this.ruleForm.he_FoodLibraryId != 0) {
        const params = {
          SchoolId: this.userInfo.SchoolId,
          he_FoodLibraryId: this.ruleForm.he_FoodLibraryId,
          he_FoodLibraryName: this.ruleForm.he_FoodLibraryName,
          Nutrient: this.ruleForm.Nutrient,
          weight: this.ruleForm.weight,
          weightType: this.ruleForm.weightType,
          reporter: this.userInfo.uRealName,
          reportDateString: this.indexInfo.date,
        };
        let res = await AddHe_FoodEveryDayDetail(params);
        if (res.data.success) {
          this.$message({
            type: "success",
            message: res.data.msg,
          });
          this.resetData();
          this.dialogVisible = false;
          await this.GetHe_FoodEverydayDetailList();
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      } else {
        this.$message({
          type: "error",
          message: "必须选择一个食材",
        });
      }
    },
    resetData() {
      this.ruleForm = {
        he_FoodLibraryName: "",
        Nutrient: "",
        weightType: "",
        weight: "",
        he_FoodLibraryId: 0,
      };
    },
    handleSelect(item) {
      this.ruleForm.Nutrient = item.Nutrient;
      this.ruleForm.he_FoodLibraryId = item.Id;
      this.ruleForm.he_FoodLibraryName = item.value;
      //console.log(item);
    },
    async GetFoodLibrary() {
      let res = await GetFoodLibrary({
        SchoolId: this.userInfo.SchoolId,
      });
      if (res.data.success) {
        this.foodList = res.data.response;
      }
    },
    async querySearchAsync(queryString, cb) {
      console.log(queryString, "queryString");
      if (queryString != "") {
        let callBackArr = [];
        this.foodList.forEach((item) => {
          if (item.Name.indexOf(queryString) > -1) {
            callBackArr.push({
              Id: item.Id,
              value: item.Name,
            });
          }
        });
        //console.log(callBackArr);
        if (callBackArr.length == 0) {
        } else {
          cb(callBackArr);
        }
      }
    },
    async GetHe_FoodEverydayDetailList() {
      const params = {
        Id: this.$route.query.Id,
        SchoolId: this.userInfo.SchoolId,
        StartDate: this.indexInfo.date,
        EndDate: this.indexInfo.date,
        PageSize: this.PageSize,
        PageIndex: this.PageIndex,
      };
      let res = await GetHe_FoodEverydayDetailList(params);
      if (res.data.success) {
        this.ishave = true;
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this.indexInfo, "date", defaultDate);
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.GetHe_FoodEverydayDetailList();
    },
    onClickAdd() {
      this.resetData();
      this.PageIndex = 1;
      this.Title = "新增今日上报食材";
      this.dialogVisible = true;
      this.GetFoodLibrary();
    },
  },
};
</script>
<style lang="less" scoped>
.el-button--goon {
  color: #fff;
  background-color: #5474e6;
  border-color: #5474e6;
  height: 34px;
  line-height: 34px;
  padding: 0 20px;
}
</style>